type Environment = "production" | "staging" | "development" | "relcert";

/**
 * Gets the current environment:
 * - "production"
 * - "staging"
 * - "development"
 * - "relcert"
 *
 * Looks in these places in this order:
 * - process.env.ENV
 * - process.env.REACT_APP_ENV_NAME
 * - process.env.envName
 *
 * @example
 * ```ts
 * const environment = getEnvironment();
 * ```
 */
const getEnvironment = (): Environment => {
  const environment =
    process.env.ENV ?? process.env.REACT_APP_ENV_NAME ?? process.env.envName;
  if (!environment)
    throw new Error(
      "Missing ENV, REACT_APP_ENV_NAME, or envName on process.env!",
    );
  switch (environment) {
    case "prd":
    case "production":
      return "production";
    case "development":
    case "devmaj":
      return "development";
    case "relcert":
      return "relcert";
    case "majstg":
    case "staging":
    default:
      return "staging";
  }
};

export { type Environment, getEnvironment };
